import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEventCalendar } from "@/hooks/useEvents";

const monthName = (i) => ["January","February","March","April","May","June","July","August","September","October","November","December"][i];
const WEEKDAY_HEADERS = [["sun", "S"], ["mon", "M"], ["tue", "T"], ["wed", "W"], ["thu", "T"], ["fri", "F"], ["sat", "S"]];

export const EventCalendar = ({ events, cursor, onPrev, onNext }) => {
  const { cells, eventsByDate } = useEventCalendar(events, cursor);
  const todayStr = new Date().toDateString();

  return (
    <div className="bg-[#F7F8FA] border border-gray-100 rounded-sm p-6 sm:p-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#003B5C]" data-testid="calendar-month-label">
          {monthName(cursor.month)} {cursor.year}
        </h2>
        <div className="flex gap-2">
          <button data-testid="calendar-prev" onClick={onPrev} className="w-10 h-10 rounded-sm bg-white border border-gray-200 hover:border-[#003B5C] flex items-center justify-center transition-colors">
            <ChevronLeft size={16} />
          </button>
          <button data-testid="calendar-next" onClick={onNext} className="w-10 h-10 rounded-sm bg-white border border-gray-200 hover:border-[#003B5C] flex items-center justify-center transition-colors">
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1 mb-2">
        {WEEKDAY_HEADERS.map(([key, label]) => (
          <div key={key} className="text-center text-xs font-bold uppercase tracking-wider text-[#1E1E1E]/50 py-2">{label}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map(({ key, day }) => {
          const dayEvents = day ? eventsByDate[`${cursor.year}-${cursor.month}-${day}`] : null;
          const isToday = day && todayStr === new Date(cursor.year, cursor.month, day).toDateString();
          return (
            <div
              key={key}
              data-testid={day ? `calendar-day-${cursor.year}-${cursor.month + 1}-${day}` : undefined}
              className={`aspect-square p-1.5 sm:p-2 rounded-sm border text-sm relative ${day ? "bg-white border-gray-100" : "border-transparent"} ${dayEvents ? "border-[#D4A437] bg-[#D4A437]/5" : ""} ${isToday ? "ring-2 ring-[#003B5C]" : ""}`}
            >
              {day && (
                <>
                  <div className={`text-xs font-semibold ${dayEvents ? "text-[#003B5C]" : "text-[#1E1E1E]/70"}`}>{day}</div>
                  {dayEvents && <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-[#D4A437]" />}
                </>
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-5 flex items-center gap-2 text-xs text-[#1E1E1E]/60">
        <span className="w-2 h-2 rounded-full bg-[#D4A437]" /> Event day
      </div>
    </div>
  );
};
